module.exports = __webpack_public_path__ + "static/media/footerImg.cddeca7f.png";